// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscription_message[data-v-40763217]{line-height:1.3}", "",{"version":3,"sources":["webpack://./resources/client/modules/account/components/AccountPaymentMethod.vue"],"names":[],"mappings":"AACA,uCACE,eAAF","sourcesContent":["\n.subscription_message {\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
